<template>
  <div class="a-content">
    <!-- 轮播 -->
    <div class="lunbo" v-if="$route.meta.banner">
      <a-carousel dotsClass="dot" autoplay>
        <div v-for="(item,i) in banner" :key="i">
          <a :href="item.link"><img :src="'http://'+item.image_file"></a>
        </div>
      </a-carousel>
    </div>
    <!-- 介绍 -->
    <div class="about">
      <div class="main-center about_info">
        <img src="../assets/img/about6.png" >
        <div class="info">
          <div class="title font-bold main-font30 margin-b-20"><span class="line"></span><span>{{$t('title.gsjj')}}</span></div>
          <div class="main-font16">
            {{$t('content.index_about_info')}}
          </div>
        </div>
      </div>
      <div class="main-center about_info">
        <div class="info">
          <div class="title font-bold main-font30 margin-b-20"><span class="line"></span><span>{{$t('title.zycp')}}</span></div>
          <div class="main-font16">
            {{$t('content.about_info_2')}}
          </div>
        </div>
        <img src="../assets/img/about1.png" >
      </div>
      <div class="main-center about_info">
        <img src="../assets/img/about5.png" >
        <div class="info">
          <div class="title font-bold main-font30 margin-b-20"><span class="line"></span><span>{{$t('title.gsry')}}</span></div>
          <div class="main-font16">
            {{$t('content.about_info_3')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return{
        banner:''
      }
    },
    created() {
      this.init(this.$store.state.langStates)
    },
    watch:{
      "$route": {
        handler(route) {
          const that = this
          if (route.name === '/about') {
            that.init(that.$store.state.langStates)
          }
        }
      },
      '$store.state.langStates': function(val) {
        this.init(val)
      }
    },
    methods:{
      init(lang){
        // 获取banner
        this.$api.dongjuapi.banner({
          type:'about'
        }).then(res=>{
          if(res.data.code==200){
            this.banner = res.data.data
          }
        })
      },
    }
  }
</script>
<style lang="less">
  .a-content{
    .about{
      background: #fff;
      padding-top: 80px;
      .about_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 80px;
        img{
          width: 520px;
          height: 290px;
        }
        .info{
          width: 720px;
          height: auto;
          .title{
            height: 50px;
            display: flex;
            align-items: center;
            .line{
              width: 6px;
              height: 50px;
              display: inline-block;
              background: #101010;
              margin-right: 12px;
            }
          }
          .main-font16{
            line-height: 30px;
          }
        }
      }
    }
  }

</style>
